import React, { useState, useEffect } from 'react';
import styles from '@/pages/camp/components/css/campCSS.less';
import { useRequest } from 'umi';
import { listVideoLog } from '@/utils/requests/camp/requests_admin';
import { VideoLogListVO } from '@/types/camp/admin/studentType';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { formatDurationSimple } from '@/pages/camp/util/indexUtil';
import useScrollHeight from '@/hooks/useScrollHeight';

interface Props {
  batchId: string;
  signUpId: string;
}

const VideoLog: React.FC<Props> = ({ batchId, signUpId }) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const scrollHeight = useScrollHeight();

  // 获取接口
  const { run: listVideoLogRequest } = useRequest(
    () => {
      return listVideoLog(batchId, signUpId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        const nodeMap = new Map();
        res.forEach((node: any, nodeIndex: any) => {
          node.videoLogList?.forEach((video: any, videoIndex: any) => {
            const key = `${nodeIndex}-${videoIndex}`;
            const item = {
              key,
              nodeName: node.name,
              videoName: video.videoName,
              videoTotalTime: video.videoTotalTime,
              duration: video.duration,
              createdTime: video.videoRepeatLogList?.map((item: any) =>
                dayjs(item.createdTime).format('YYYY-MM-DD HH:mm'),
              ) || ['--'],
              lookDuration: video.videoRepeatLogList?.map((item: any) =>
                item.duration ? formatDurationSimple(item.duration) : '--',
              ) || ['--'],
              nodeIndex,
              videoIndex,
              nodeId: node.id,
            };
            if (nodeMap.has(node.id)) {
              nodeMap.get(node.id).push(item);
            } else {
              nodeMap.set(node.id, [item]);
            }
          });
        });

        const flattenedData: any = [];
        nodeMap.forEach((group, nodeId) => {
          const rowSpan = group.length;
          group.forEach((item: any, index: any) => {
            flattenedData.push({
              ...item,
              rowSpan: index === 0 ? rowSpan : 0,
            });
          });
        });

        console.log('flattenedData', flattenedData);
        setData(flattenedData);
        setLoading(false);
      },
    },
  );

  useEffect(() => {
    listVideoLogRequest();
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: '节点名称',
      dataIndex: 'nodeName',
      key: 'nodeName',
      onCell: (record) => {
        return {
          rowSpan: record.rowSpan,
        };
      },
    },
    {
      title: '视频名称',
      dataIndex: 'videoName',
      key: 'videoName',
      width: 300,
    },
    {
      title: '视频总时长',
      dataIndex: 'videoTotalTime',
      key: 'videoTotalTime',
      render: (value) => (value ? formatDurationSimple(value) : '--'),
    },
    {
      title: '观看总时长',
      dataIndex: 'duration',
      key: 'duration',
      render: (value) => (value ? formatDurationSimple(value) : '--'),
    },
    {
      title: '开始观看时间',
      dataIndex: 'createdTime',
      key: 'createdTime',
      render: (value) => {
        return (
          <div className="col595">
            {Array.isArray(value) ? value.map((time, index) => <p key={index}>{time}</p>) : '--'}
          </div>
        );
      },
    },
    {
      title: '观看耗时',
      dataIndex: 'lookDuration',
      key: 'lookDuration',
      render: (value) => {
        return (
          <div className="col595">
            {Array.isArray(value) ? value.map((time, index) => <p key={index}>{time}</p>) : '--'}
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Table
        rowKey="key"
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        className={styles.study_log_table}
        scroll={{ y: scrollHeight }}
      />
    </div>
  );
};

export default VideoLog;
